<template>
    <div>
        <headline-container headline="Subscription Types" :breadcrumbs="[{text: 'Subscription Types'}]">
            <router-link to="/subscription-types/create" class="btn btn-white">
                <i class="fa fa-plus"></i> Create
            </router-link>
        </headline-container>

        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="panel panel-default">
                <div class="panel-body">
                    <table class="table table-condensed table-striped">
                        <thead>
                            <tr>
                                <th class="col-xs-1 text-center">
                                    <input type="checkbox" v-model="selectAll">
                                </th>

                                <th class="col-xs-10">
                                    Name
                                </th>

                                <th class="col-xs-6">
                                    Price
                                </th>

                                <th class="col-xs-6">
                                    Portal
                                </th>

                                <th class="col-xs-1"></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="subscriptionType in subscriptionTypes">
                                <td class="text-center">
                                    <input type="checkbox" v-model="selected" :value="subscriptionType">
                                </td>

                                <td>
                                    <router-link :to="'/subscription-types/' + subscriptionType.id + '/edit'">
                                        {{ subscriptionType.attributes.name }}
                                    </router-link>
                                </td>

                                <td>
                                    {{ subscriptionType.attributes.price | price }}
                                </td>

                                <td>
                                    {{ subscriptionType.attributes.portal_name }}
                                </td>

                                <td class="text-right">
                                    <div class="btn-group list-actions">
                                        <router-link :to="'/subscription-types/' + subscriptionType.id + '/edit'" class="btn btn-sm">
                                            <i class="fa fa-search"></i>
                                        </router-link>

                                        <button type="button" class="btn btn-sm" @click="destroy(subscriptionType)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            <tr v-if="!subscriptionTypes.length">
                                <td colspan="5" class="text-center">
                                    <i>
                                        There are no subscription types to display.
                                    </i>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="dropdown" v-if="selected.length">
                        <button
                                class="btn btn-black btn-sm dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                        >
                            <i class="fa fa-cogs"></i> List Actions <span class="caret"></span>
                        </button>

                        <ul class="dropdown-menu">
                            <li>
                                <a href="#" @click.prevent="destroySelected">
                                    <i class="fa fa-trash"></i> Delete
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import notify from '@/notify'
    import HeadlineContainer from '@/components/Layout/HeadlineContainer'
    import Load from '@/mixins/Load'
    import LoadingContainer from '@/components/Layout/LoadingContainer'

    export default {
        components: {HeadlineContainer, LoadingContainer},

        data() {
            return {
                subscriptionTypes: [],
                loading: true,
                selected: [],
                selectAll: false
            }
        },

        watch: {
            selectAll(value) {
                this.selected = value ? this.subscriptionTypes : []
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            load() {
                this.loading = true

                http.get('/api/v2/subscription-types', this.filters)
                    .then(response => {
                        this.subscriptionTypes = response.data.data

                        this.loading = false
                    })
            },

            destroy(subscriptionType) {
                modal.confirm('Are you sure that you want to delete the subscription type?', () => {
                    this.getDestroyPromise(subscriptionType)
                        .then(() => {
                            notify.success('The subscription type was deleted')

                            this.load()
                        })
                })
            },

            destroySelected() {
                modal.confirm('Are you sure that you want to delete the subscription types?', () => {
                    axios.all(this.selected.map(subscriptionType => this.getDestroyPromise(subscriptionType)))
                        .then(() => {
                            notify.success('The subscription types were deleted')

                            this.load()

                            this.resetSelections()
                        })
                })
            },

            getDestroyPromise(subscriptionType) {
                return http.delete('/api/v2/subscription-types/' + subscriptionType.id)
            },

            resetSelections() {
                this.selected = []

                this.selectAll = false
            }
        }
    }
</script>
